import { getVisitorId } from "./visitorId";
import { hasAnalyticsConsent } from "./consent";

const FUNCTIONS_BASE = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/download-file`;

export type TrackedFile =
  | "broschuere-2025"
  | "leitfaden-technikerzettel"
  | "studien-zusammenfassung-2026"
  | "ai-press-onepager";

/** Direct file paths — used when the visitor did not consent to tracking. */
const DIRECT_PATHS: Record<TrackedFile, string> = {
  "broschuere-2025": "/downloads/eap-broschuere-2025.pdf",
  "leitfaden-technikerzettel": "/downloads/leitfaden-technikerzettel.pdf",
  "studien-zusammenfassung-2026": "/downloads/eap-studien-zusammenfassung-2026.html",
  "ai-press-onepager": "/downloads/eap-ai-press-onepager.html",
};

/**
 * Returns the download URL.
 *
 * With analytics consent: a URL that counts the download server-side and then
 * redirects to the file, carrying only a pseudonymous visitor marker so
 * downloads can be linked to later enquiries.
 * Without consent: the plain file path — no logging, no marker.
 */
export const trackedDownloadUrl = (file: TrackedFile, language?: string) => {
  if (!hasAnalyticsConsent()) return DIRECT_PATHS[file];

  const params = new URLSearchParams({ file });
  if (language) params.set("lang", language);
  const vid = getVisitorId();
  if (vid) params.set("vid", vid);
  return `${FUNCTIONS_BASE}?${params.toString()}`;
};
